"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.agentColumns = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../../Icon");
const balanceColumn_1 = require("../../Table/columns/balanceColumn");
exports.agentColumns = [
    {
        Header: 'Email',
        accessor: 'email',
    },
    {
        Header: 'Name',
        accessor: 'displayName',
    },
    {
        Header: 'Phone',
        accessor: 'phoneNumberFirst',
        disableSortBy: true,
    },
    {
        Header: 'Street',
        accessor: 'street',
    },
    {
        Header: 'City',
        accessor: 'city',
    },
    {
        Header: 'Credit Limit',
        id: 'creditLimitTotalAmount',
        canSort: true,
        Cell: ({ row }) => react_1.default.createElement("span", null,
            row.original.creditLimitTotalAmount,
            " CHF"),
    },
    {
        Header: 'Margin',
        id: 'margin',
        disableSortBy: true,
        Cell: ({ row }) => {
            const agent = row.original;
            const margin = agent.marginType === 'percent'
                ? `${agent.percentMargin} %`
                : `${agent.moneyMargin} CHF`;
            return (react_1.default.createElement("span", null, margin));
        },
    },
    (0, balanceColumn_1.balanceColumn)(),
    {
        Header: 'Info',
        id: 'info',
        Cell: () => {
            return (react_1.default.createElement("span", { className: 'table__action-icons' },
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'edit' })),
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'dollar-circle' })),
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'check-list' })),
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'x' }))));
        },
    },
];
//# sourceMappingURL=tableColumns.js.map